export default "__VITE_ASSET__DGeUjYtc__"